var _g, _g2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFitur3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_462_20739)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 60,
    r: 60,
    fill: "#D0D1D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_462_20739)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 60,
    r: 55,
    stroke: "#D0D1D3",
    strokeWidth: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 30,
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_462_20739",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_20739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_20739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_462_20739",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_20739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_20739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_462_20739",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_462_20739",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAEKUlEQVR4nO2dS2jVQBSGv1sfbcWuFGurLhTEB2oVFATdulVEpCi4URFdWFfagi66tririOBGiyDuXLnUIr5AfOFjVxFfFayKtypa6XUxuVIhyc1kJjNJej44UHInZ/785M4kJ3NTEARBEARBEARBKDktwDHgPjAO1Aoe48A9oAdotuiTEYuBJ/g3J6t4HByjV1oot8lTzfZ6Zh8LEVXWOGrJs1TcjxBVxrhrYlTFZGegCsw1zFEUxoG2tDubGl0z3L9opParyaYKIRox2hGujf4N9AKLgugLtiVpX7EUSfrNHbozd29Ijl7N9raI6zcqvKErtCMkx0LN9raI69e60a6HjrBZe4Zme1vE9Wsd10bvS7gtyWemZJnbOrpfvV+osbEziN5gW5L2tkjSr/WhQ25Y9JAblrwjRjtCjHaEGO0IMdoRUusoCFLrcITUOhIitQ5HSK2jIEitIyFS69BDah15R4x2hBjtCDHaEWK0I6TWURCk1uEIqXUkRGodjpBaR0GQWkdCpNahh9Q68o4Y7YiZvgU45AtwHRgGHgAfgU/AbGA+sAzYCmwDtoTsX6jraB/xHDgAtGoc10rgHDCBuoM8D6zW2N86vk2Mi3HgODDL4PhWBOGdNJd3J9C7vKu3n9boGp2nWkeh0DU6T7UOp+Sh1hGnwXatow01MV4DRoCfwBjwCDgNrEuQowsYQL3xYCzIMRLk3E9GP9m2MXT0abZPQwU4jLqki9M3CVwBFoTkaAeuBm3icowChyzp/keaydB1raMFuKypcxRYPyXHhmCbTo4hLL7jQ9forOJghL4K+ibX4zOwEdgU/J0mx5CGl7H4NrgGfCP6ZuSIYe73QZjksDKM+Da5hho3w2ij8ZjsIkaBuWUoKg1HbO8mfFJzTTuwuwxGP43Yvt2pinh2lMHoNxHb1zpVEY+xFt3xymWt40cKfVnFjxT6/0O3Q5e1jmoKfVlF1eA4IEWHYWdmp2b7pLxKoS+rGMnDGJ3V2o2oSdIHj8u8ruO2wb62uWOaQPcr5LLWsTyFvixiEliaQv9/+D6IGvCW6FLrrRzou5Hczmh8H0Q9wp5aA+zMgTYrN06+D6IeZyP0VfB7Vt/E0mSfl2vV78C8CI1rUMsGXGuaQD2NAcwfZb0w3N8Wc1BPUMJ4hlqX4ZqzqJeYW6EH/2dzPb6iVhyF0Qa8dKjlBZafHTajHlL6NrkegzFaV+NmqKsCq5JbmJzF5MfsP8DmGK17HGjo1jFPl2bUO/Dv4n+CfIl6IBtFf4Z99+vZVn7OYN/kuGFr2tIEXMKeyRfJ9odNhWYGcAFzk4eYXuvMU1HBbBgZRH41ocUpGi/1mhqTwEkvSkvALtStfCOTfwJ7PWksDV3Aa6JNfodaJiZYoIPwf031EFjiUVcpaUWtl/6AWlY2QPxNUEP+AvxedyiykS2eAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitur3);
export default __webpack_public_path__ + "static/media/fitur3.36bc83ad01b2fc2f780ac07bb3aaf4ee.svg";
export { ForwardRef as ReactComponent };